export default __webpack_public_path__ + "static/media/me.c4e84451.JPG";